import axios from '../config/axios';
import showToast from '../components/ToastComponent';
import { AxiosError } from 'axios';

export const callCustomerAddresses = async (accessToken: string) => {
  try {
    if (!accessToken) return false;
    const response = await axios('/api/v1/patients/address', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response?.data || [];
  } catch (e) {
    console.error(e as AxiosError);
    showToast({
      message: 'Unable to fetch saved shipping addresses.',
      type: 'error',
    });
    return [];
  }
};
